/* NOTE23 Inari \u2013 Personalisierung + Live-Vorschau (v1) */
(function(){
'use strict';
function boot(){
var root = document.querySelector('[data-n23i]');
if (!root || root.__n23i) return;
root.__n23i = true;
root.classList.add('n23x');

var FORM = root.getAttribute('data-form') || '';
if (!document.getElementById(FORM)) { var f0 = document.querySelector('form[id^="BuyButtons-ProductForm"]'); if (f0) FORM = f0.id; }
var L = (root.getAttribute('data-loc') || document.documentElement.lang || 'de').slice(0,2).toLowerCase();
var HANDLE = root.getAttribute('data-handle') || (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
var MAX = 8, NAMEMAX = 12;

var T = {
de:{color:'Farbe',black:'Schwarz',cnt:'Anzahl der Charms',o1:'1 Charm \u2013 inklusive',on:'{n} Charms',font:'Schriftart:',fn:{modern:'Modern',klassisch:'Klassisch'},live:'LIVE-VORSCHAU',note:'Die Vorschau dient zur Orientierung \u2013 jede Gravur wird vor der Fertigung von uns gepr\u00fcft und sauber ausgerichtet.',your:'Deine Gravur',slot:'Charm',ph:'z. B. ',dph:'TT.MM.JJJJ',dlab:'Datum (optional)',hint:'Max. 12 Zeichen pro Name. Datum optional \u2013 z. B. 12.03.2018, 12.03.18 oder nur 12.03. Wir gravieren genau so, wie du es eingibst \u2013 inklusive Gro\u00df- und Kleinschreibung.',eta:'\u270d\ufe0f Von uns graviert \u00b7 \ud83d\udce6 Lieferzeit: 4\u20136 Werktage inkl. Gravur.',errN:'Bitte gib f\u00fcr jeden Charm einen Namen ein.',errD:'Bitte pr\u00fcf das Datum \u2013 z. B. 12.03.2018, 12.03.18 oder 12.03.',kN:'Name',kD:'Datum',kF:'Schriftart',kC:'Farbe',feat:'Pr\u00e4zise Lasergravur',ban:'Du bearbeitest einen Artikel aus deinem Warenkorb. Beim Hinzuf\u00fcgen wird er ersetzt.'},
en:{color:'Colour',black:'Black',cnt:'Number of charms',o1:'1 charm \u2013 included',on:'{n} charms',font:'Font:',fn:{modern:'Modern',klassisch:'Classic'},live:'LIVE PREVIEW',note:'The preview is for orientation \u2013 we check and align every engraving before production.',your:'Your engraving',slot:'Charm',ph:'e.g. ',dph:'DD.MM.YYYY',dlab:'Date (optional)',hint:'Max. 12 characters per name. Date optional \u2013 e.g. 12.03.2018, 12.03.18 or just 12.03. We engrave exactly what you enter \u2013 including upper and lower case.',eta:'\u270d\ufe0f Engraved by us \u00b7 \ud83d\udce6 Delivery: 4\u20136 business days incl. engraving.',errN:'Please enter a name for every charm.',errD:'Please check the date \u2013 e.g. 12.03.2018, 12.03.18 or 12.03.',kN:'Name',kD:'Date',kF:'Font',kC:'Colour',feat:'Precise laser engraving',ban:'You are editing an item from your cart. Adding it will replace the old one.'},
sv:{color:'F\u00e4rg',black:'Svart',cnt:'Antal berlocker',o1:'1 berlock \u2013 ing\u00e5r',on:'{n} berlocker',font:'Typsnitt:',fn:{modern:'Modern',klassisch:'Klassisk'},live:'LIVEF\u00d6RHANDSVISNING',note:'F\u00f6rhandsvisningen \u00e4r en v\u00e4gledning \u2013 vi kontrollerar och justerar varje gravyr f\u00f6re tillverkningen.',your:'Din gravyr',slot:'Berlock',ph:'t.ex. ',dph:'DD.MM.\u00c5\u00c5\u00c5\u00c5',dlab:'Datum (valfritt)',hint:'Max 12 tecken per namn. Datum valfritt \u2013 t.ex. 12.03.2018, 12.03.18 eller bara 12.03. Vi graverar exakt det du skriver \u2013 \u00e4ven stora och sm\u00e5 bokst\u00e4ver.',eta:'\u270d\ufe0f Graverat av oss \u00b7 \ud83d\udce6 Leveranstid: 4\u20136 arbetsdagar inkl. gravyr.',errN:'Ange ett namn f\u00f6r varje berlock.',errD:'Kontrollera datumet \u2013 t.ex. 12.03.2018, 12.03.18 eller 12.03.',kN:'Namn',kD:'Datum',kF:'Typsnitt',kC:'F\u00e4rg',feat:'Precis lasergravyr',ban:'Du \u00e4ndrar en artikel fr\u00e5n din varukorg. N\u00e4r du l\u00e4gger till ers\u00e4tts den gamla.'},
fi:{color:'V\u00e4ri',black:'Musta',cnt:'Helojen m\u00e4\u00e4r\u00e4',o1:'1 hela \u2013 sis\u00e4ltyy',on:'{n} helaa',font:'Fontti:',fn:{modern:'Moderni',klassisch:'Klassinen'},live:'ESIKATSELU',note:'Esikatselu on suuntaa antava \u2013 tarkistamme ja kohdistamme jokaisen kaiverruksen ennen valmistusta.',your:'Kaiverruksesi',slot:'Hela',ph:'esim. ',dph:'PP.KK.VVVV',dlab:'P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 (valinnainen)',hint:'Enint\u00e4\u00e4n 12 merkki\u00e4 nime\u00e4 kohden. P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 valinnainen \u2013 esim. 12.03.2018, 12.03.18 tai vain 12.03. Kaiverramme juuri niin kuin kirjoitat \u2013 my\u00f6s isot ja pienet kirjaimet.',eta:'\u270d\ufe0f Kaiverramme itse \u00b7 \ud83d\udce6 Toimitus: 4\u20136 arkip\u00e4iv\u00e4\u00e4 kaiverruksineen.',errN:'Kirjoita nimi jokaiseen helaan.',errD:'Tarkista p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 \u2013 esim. 12.03.2018, 12.03.18 tai 12.03.',kN:'Nimi',kD:'P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4',kF:'Fontti',kC:'V\u00e4ri',feat:'Tarkka laserkaiverrus',ban:'Muokkaat ostoskorisi tuotetta. Lis\u00e4tt\u00e4ess\u00e4 vanha korvataan.'}
};
var t = T[L] || T.de;
var DEMO = [['Emma','12.03.2018'],['Paul','04.09.2021'],['Mia',''],['Leon',''],['Lina',''],['Noah',''],['Ella',''],['Ben','']];
var state = { n:1, font:'modern', rows:[{name:'',date:''}] };
var P = null, CNT_IDX = -1;

function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function $(s){ return root.querySelector(s); }

/* ---------- Markup ---------- */
root.innerHTML =
'<div class="n23x__field"><span class="n23x__lbl">' + esc(t.cnt) + '</span><div class="n23x__sel"><select data-cnt aria-label="' + esc(t.cnt) + '"></select></div></div>' +
'<div class="n23x__field n23x__field--row"><span class="n23x__lbl">' + esc(t.font) + ' <b data-fontname></b></span><div class="n23x__fonts" role="radiogroup" aria-label="' + esc(t.font) + '">' +
'<button type="button" class="n23x__font" data-f="klassisch" role="radio" title="' + esc(t.fn.klassisch) + '"><span style="font-family:\'Old Standard TT\',Georgia,serif">Aa</span></button>' +
'<button type="button" class="n23x__font" data-f="modern" role="radio" title="' + esc(t.fn.modern) + '"><span style="font-family:\'Arimo\',Arial,sans-serif">Aa</span></button></div></div>' +
'<div class="n23x-pv" aria-hidden="true"><span class="n23x-pv__pill">' + esc(t.live) + '</span><div class="n23x-band"></div><div class="n23x-sl"></div></div>' +
'<div class="n23x__field"><span class="n23x__lbl">' + esc(t.your) + '</span><div class="n23x-list"></div></div>' +
'<p class="n23x__hint">' + esc(t.hint) + '</p>' +
'<p class="n23x__err" data-err></p>' +

'<div class="n23x-hidden"></div>';

/* ---------- Varianten ---------- */
function groups(){ var vp = document.querySelector('variant-picker'); return vp ? [].slice.call(vp.querySelectorAll('fieldset.variant-option')) : []; }
function countGroup(){ var g = groups(); if (CNT_IDX >= 0 && g[CNT_IDX]) return g[CNT_IDX]; return g[g.length - 1] || null; }
function checkedIndex(fs){ var ins = [].slice.call(fs.querySelectorAll('input[type=radio]')); for (var i = 0; i < ins.length; i++) if (ins[i].checked) return i; var s = fs.querySelector('select'); return s ? s.selectedIndex : -1; }
function selectCount(n){
var fs = countGroup(); if (!fs) return;
var ins = fs.querySelectorAll('input[type=radio]');
if (ins.length) { var r = ins[n-1]; if (r && !r.checked) r.click(); return; }
var s = fs.querySelector('select'); if (s && s.options[n-1] && s.selectedIndex !== n-1) { s.selectedIndex = n-1; s.dispatchEvent(new Event('change', { bubbles:true })); }
}
function readVariant(){
var fs = countGroup(); if (!fs) return;
var i = checkedIndex(fs); if (i >= 0 && i + 1 !== state.n) setCount(i + 1, true);
}
function money(c){
try { return new Intl.NumberFormat(L === 'en' ? 'en-IE' : L === 'sv' ? 'sv-SE' : L === 'fi' ? 'fi-FI' : 'de-DE', { style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100).replace(/\s/g, ''); }
catch(e) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20ac'; }
}
function buildSelect(){
var sel = $('[data-cnt]'), h = '', base = null, diffs = {};
if (P && CNT_IDX >= 0) {
var cur = P.variants.filter(function(v){ return v.available !== false; });
cur.forEach(function(v){ var n = parseInt(v.options[CNT_IDX], 10); if (!n) return; if (diffs[n] == null || v.price < diffs[n]) diffs[n] = v.price; });
base = diffs[1];
}
for (var n = 1; n <= MAX; n++) {
var lab = n === 1 ? t.o1 : t.on.replace('{n}', n);
if (n > 1 && base != null && diffs[n] != null) lab += ' (+' + money(diffs[n] - base) + ')';
h += '<option value="' + n + '">' + esc(lab) + '</option>';
}
sel.innerHTML = h; sel.value = String(state.n);
}

/* ---------- Zeilen ---------- */
function setCount(n, fromVariant){
n = Math.max(1, Math.min(MAX, n | 0));
while (state.rows.length < n) state.rows.push({ name:'', date:'' });
state.rows.length = n; state.n = n;
renderRows(); renderPreview(); syncHidden();
var s = $('[data-cnt]'); if (s && s.value !== String(n)) s.value = String(n);
if (!fromVariant) selectCount(n);
}
function renderRows(){
var h = '';
state.rows.forEach(function(r, i){
h += '<div class="n23x-row" data-i="' + i + '"><div class="n23x-row__h">' + esc(t.slot) + ' ' + (i+1) + '</div><div class="n23x-row__f">' +
'<div class="n23x-in"><input type="text" data-k="name" maxlength="' + NAMEMAX + '" autocomplete="off" spellcheck="false" placeholder="' + esc(t.ph + DEMO[i][0]) + '" aria-label="' + esc(t.slot + ' ' + (i+1) + ' \u2013 ' + t.kN) + '" value="' + esc(r.name) + '"><small>' + r.name.length + '/' + NAMEMAX + '</small></div>' +
'<div class="n23x-in"><input type="text" data-k="date" maxlength="10" inputmode="decimal" autocomplete="off" placeholder="' + esc(t.dph) + '" aria-label="' + esc(t.dlab) + '" value="' + esc(r.date) + '"></div>' +
'</div></div>';
});
$('.n23x-list').innerHTML = h;
}
function cleanName(v){ return String(v).replace(/[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u00ff\u0100-\u017f0-9 .&\u2665'\-]/g, ''); }
function cleanDate(v){ return String(v).replace(/[^0-9.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./, '').slice(0, 10); }
function dclean(d){ return String(d || '').replace(/\.+$/, ''); }
function dateOk(d){ var m = /^(\d{1,2})\.(\d{1,2})(?:\.(\d{2}|\d{4}))?$/.exec(d); return !!m && +m[1] >= 1 && +m[1] <= 31 && +m[2] >= 1 && +m[2] <= 12; }

root.addEventListener('input', function(e){
var inp = e.target, row = inp.closest && inp.closest('.n23x-row'); if (!row) return;
var i = +row.getAttribute('data-i'), k = inp.getAttribute('data-k');
var nv = k === 'date' ? cleanDate(inp.value) : cleanName(inp.value);
if (nv !== inp.value) { var p = inp.selectionStart - (inp.value.length - nv.length); inp.value = nv; try { inp.setSelectionRange(p, p); } catch(_){} }
state.rows[i][k] = inp.value;
if (k === 'name') { var sm = inp.parentNode.querySelector('small'); if (sm) sm.textContent = inp.value.length + '/' + NAMEMAX; }
inp.classList.remove('is-err'); $('[data-err]').classList.remove('is-on');
renderPreview(); syncHidden();
});
root.addEventListener('change', function(e){ if (e.target.matches && e.target.matches('[data-cnt]')) setCount(+e.target.value); });
root.addEventListener('click', function(e){
var f = e.target.closest && e.target.closest('[data-f]');
if (f) { setFont(f.getAttribute('data-f')); }
});
function setFont(v){
state.font = v; root.setAttribute('data-font', v);
root.querySelectorAll('[data-f]').forEach(function(b){ var on = b.getAttribute('data-f') === v; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
$('[data-fontname]').textContent = t.fn[v];
renderPreview(); syncHidden();
}

/* ---------- Vorschau ---------- */
function renderPreview(){
var h = '';
state.rows.forEach(function(r, i){
var empty = !r.name.trim(), nm = empty ? DEMO[i][0] : r.name, dv = dclean(r.date), dt = dv || (empty ? DEMO[i][1] : ''), dph = !dt && !empty;
if (dph) dt = t.dph;
h += '<div class="n23x-s' + (empty ? ' is-empty' : '') + '"><div class="n23x-t"><span class="n23x-t__n">' + esc(nm) + '</span>' + (dt ? '<span class="n23x-t__d' + (dph ? ' is-ph' : '') + '">' + esc(dt) + '</span>' : '') + '</div></div>';
});
$('.n23x-sl').innerHTML = h;
fit();
}
function fit(){
var pv = $('.n23x-pv'), ss = root.querySelectorAll('.n23x-s'); if (!pv || !ss.length) return;
var cw = pv.clientWidth || 340, n = ss.length;
/* Schieber: Breite:H\u00f6he \u2248 0,56 wie beim echten Armband */
/* Schieber hochkant wie auf den Produktfotos (B:H = 0,78), Band = 0,74 der Schieberhoehe */
var R = 0.78;
var sh = Math.min(cw < 500 ? 104 : 116, ((cw * 0.90) - (n - 1) * 1) / n / R);
sh = Math.max(46, sh);
var sw = sh * R;
pv.style.setProperty('--sh', sh + 'px'); pv.style.setProperty('--sw', sw + 'px');
pv.style.setProperty('--bh', (sh * 0.74) + 'px');
pv.style.setProperty('--pvh', Math.max(110, sh + 34) + 'px');
var inner = sh * 0.72;           /* nutzbare Laenge entlang des Schiebers (Text senkrecht) */
ss.forEach(function(s){
var nm = s.querySelector('.n23x-t__n'), dt = s.querySelector('.n23x-t__d');
var fs = sw * 0.25, fd = sw * 0.13;
s.style.setProperty('--fs', fs + 'px'); s.style.setProperty('--fd', fd + 'px'); s.style.setProperty('--gap', (sw * 0.05) + 'px');
s.style.setProperty('--sx', 1); s.style.setProperty('--sxd', 1);
var w = nm.offsetWidth;
if (w > inner) { var k = inner / w; if (k < 0.62) { fs = fs * Math.max(0.62, k / 0.8); s.style.setProperty('--fs', fs + 'px'); w = nm.offsetWidth; k = w > inner ? inner / w : 1; } s.style.setProperty('--sx', k); }
if (dt) { var wd = dt.offsetWidth; if (wd > inner) s.style.setProperty('--sxd', inner / wd); }
});
}
window.addEventListener('resize', fit);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
if (window.ResizeObserver) new ResizeObserver(fit).observe($('.n23x-pv'));

/* ---------- Line-Item-Properties ---------- */
function syncHidden(){
var h = '<input type="hidden" form="' + esc(FORM) + '" name="properties[' + esc(t.kF) + ']" value="' + esc(t.fn[state.font]) + '">';
state.rows.forEach(function(r, i){
var d = dclean(r.date), v = r.name.trim() + (d ? ' \u00b7 ' + d : '');
h += '<input type="hidden" form="' + esc(FORM) + '" name="properties[' + esc(t.slot + ' ' + (i+1)) + ']" value="' + esc(v) + '">';
});
$('.n23x-hidden').innerHTML = h;
}

/* ---------- Info-Leiste: "Verstellbare Gr\u00f6\u00dfe" passt nicht zu Inari ---------- */
function fixInfo(){
document.querySelectorAll('.n23i__icons > *').forEach(function(b){
if (/verstellbar|adjustable|justerbar|s\u00e4\u00e4dett/i.test(b.textContent)) {
for (var k = b.childNodes.length - 1; k >= 0; k--) { var nd = b.childNodes[k]; if (nd.nodeType === 3 && nd.textContent.trim()) { nd.textContent = t.feat; return; } }
}
});
}
fixInfo(); setTimeout(fixInfo, 600);

/* ---------- Pr\u00fcfung vor dem Warenkorb ---------- */
function validate(){
var bad = null, msg = '';
root.querySelectorAll('.n23x-row').forEach(function(row){
var n = row.querySelector('[data-k=name]'), d = row.querySelector('[data-k=date]'), ri = +row.getAttribute('data-i');
n.value = n.value.trim(); state.rows[ri].name = n.value;
if (!n.value) { n.classList.add('is-err'); bad = bad || n; msg = msg || t.errN; }
if (d.value) { d.value = dclean(d.value); state.rows[ri].date = d.value; if (!dateOk(d.value)) { d.classList.add('is-err'); bad = bad || d; msg = msg || t.errD; } }
});
syncHidden();
if (bad) { var er = $('[data-err]'); er.textContent = msg; er.classList.add('is-on'); bad.focus({ preventScroll:true }); bad.scrollIntoView({ behavior:'smooth', block:'center' }); return false; }
return true;
}
document.addEventListener('submit', function(e){
var f = e.target; if (!f || f.id !== FORM) return;
if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
}, true);
document.addEventListener('click', function(e){
var btn = e.target.closest && e.target.closest('button[type=submit], button[name=add], .add-to-cart-button');
if (!btn) return; var f = document.getElementById(FORM);
if (f && (btn.form === f || f.contains(btn)) && !validate()) { e.preventDefault(); e.stopPropagation(); }
}, true);

document.addEventListener('change', function(e){ if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(readVariant, 60); });
document.addEventListener('variant:update', function(){ setTimeout(readVariant, 60); });

/* ---------- Start ---------- */
setFont('modern');
renderRows(); renderPreview(); syncHidden(); buildSelect();
readVariant();

/* ---------- Bearbeiten aus dem Warenkorb (?n23edit=KEY) ---------- */
(function(){
var EK = null; try { EK = new URLSearchParams(location.search).get('n23edit'); } catch(e){}
if (!EK) return;
fetch('/cart.js', { credentials:'same-origin', cache:'no-store' }).then(function(r){ return r.json(); }).then(function(c){
var it = (c.items || []).filter(function(i){ return i.key === EK; })[0]; if (!it) return;
var p = it.properties || {}, rows = [], font = '';
Object.keys(p).forEach(function(k){
var m = /^(?:Charm|Berlock|Hela)\s+(\d+)$/.exec(k); if (m) rows[+m[1]-1] = String(p[k]);
if (/^(Schriftart|Font|Typsnitt|Fontti)$/.test(k)) font = String(p[k]).toLowerCase();
});
rows = rows.filter(function(x){ return x !== undefined; });
if (!rows.length) return;
var b = document.createElement('div'); b.className = 'n23x__ban'; b.textContent = '\u270e ' + t.ban; root.insertBefore(b, root.firstChild);
if (/klass|classic/.test(font)) setFont('klassisch'); else setFont('modern');
setTimeout(function(){
setCount(rows.length);
rows.forEach(function(v, i){ var parts = v.split(' \u00b7 '); state.rows[i] = { name: parts[0] || '', date: parts[1] || '' }; });
renderRows(); renderPreview(); syncHidden();
}, 400);
}).catch(function(){});
})();
if (HANDLE) {
fetch('/products/' + HANDLE + '.js', { credentials:'same-origin' }).then(function(r){ return r.json(); }).then(function(p){
P = p;
(p.options || []).forEach(function(o, i){ var nm = (o.name || o).toString(); if (/namen|names|namn|nime/i.test(nm)) CNT_IDX = i; });
if (CNT_IDX < 0 && p.options) CNT_IDX = p.options.length - 1;
buildSelect(); readVariant();
}).catch(function(){});
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();
